// extracted by mini-css-extract-plugin
export default {"text":"PrivacyPolicy_text__R7DJw"};